$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

var isoDfLayoutQtySpinner = function () {

    return {
        //main function to initiate the module
        init: function () {
            $('body').on('click', '.iso-df-spinner-btn-up', function () {
                var $elem = $(this).parents('.iso-df-spinner');
                var data_input = $(this).attr('data_input');
                var QTY = $elem.find('input.' + data_input);
                var data_max = ($(this).data('maximum')) ? $(this).data('maximum') : 999;
                if (QTY.val() < data_max) {
                    QTY.val(parseInt(QTY.val(), 10) + 1);
                }
                QTY.attr('new_value', QTY.val());
            }).on('click', '.iso-df-spinner-btn-down', function () {
                var $elem = $(this).parents('.iso-df-spinner');
                var data_input = $(this).attr('data_input');
                var QTY = $elem.find('input.' + data_input);
                if (QTY.val() != 1) {
                    QTY.val(parseInt(QTY.val(), 10) - 1);
                }
                QTY.attr('new_value', QTY.val());
            }).on('input, blur', '.iso-df-spinner input', function () {
                var QTY = $(this);
                if ((parseInt(QTY.val()) < 1) || isNaN(parseInt(QTY.val()))) {
                    QTY.val(1);
                }
                QTY.attr('new_value', QTY.val());
            });
        }

    };
}();

var isoDfLayoutCheckboxVisibilityToggle = function () {

    return {
        //main function to initiate the module
        init: function () {
            $('.iso-df-toggle-hide').each(function () {
                var $checkbox = $(this).find('input[type=checkbox]'),
                    $speed = $(this).data('animation-speed'),
                    $object = $('.' + $(this).data('object-selector'));

                $object.hide();

                if (typeof $speed === 'undefined') {
                    $speed = 'slow';
                }

                $($checkbox).on('change', function () {
                    if ($($object).is(':hidden')) {
                        $($object).show($speed);
                    } else {
                        $($object).slideUp($speed);
                    }
                });

                if ($checkbox.attr('checked')) {
                    $($object).show();
                }
            });
        }
    };

}();

function initQuickviewGallery () {

    // Quickview Lightbox
    var hasQvPopup = $('#quick-view-product-modal a').hasClass('open-gallery');

    if (hasQvPopup) {

        $('#quick-view-product-modal .open-gallery').magnificPopup({
            type:'image',
            gallery: {
                enabled: true
            }
        });

    }

} // initGallery

function buildAlert(message, alertType, dismissable) {
    alertType = alertType || 'success';
    var closeButton = '';
    if (dismissable) {
        closeButton = '<button type="button" class="close" data-dismiss="alert" aria-label="' + isoDfTranslations.close + '"><span aria-hidden="true">&times;</span></button>';
    }
    var alertHTML = '<div class="alert alert-' + alertType + '" role="alert">' + message + closeButton + '</div>';

    return alertHTML;
}

function copyLinkToClipboard() {

    $('#isoshop-shared-cart input').select();

    try {
        var successful = document.execCommand( 'copy' );
        if (successful) {
            $('#isoshop-shared-cart').prepend(buildAlert(isoDfTranslations.link_has_been_copied, 'success', true));
        }
        else {
            $('#isoshop-shared-cart').prepend(buildAlert(isoDfTranslations.link_copying_failed, 'danger', true));
        }
    } catch (err) {
        $('#isoshop-shared-cart').prepend(buildAlert(isoDfTranslations.link_copying_failed, 'danger', true));
    }

    $('#isoshop-shared-cart input').blur();
    $('#isoshop-shared-cart a').blur();
}

(function ( $ ) {
    'use strict';

    $.fn.extend({

        saveCart: function () {
            var element = $(this);
            var csrfToken = $(element).data('csrf-token');
            var dataUrl = $(element).data('url');

            $(this).on('click', function(e) {

                var listName = $('#isoshop-save-cart-list-name').val();

                if (listName) {

                    $.ajax({
                        method: 'POST',
                        url: dataUrl,
                        cache: false,
                        data: { _csrf_token : csrfToken, name: listName },
                        success: function (response) {
                            element.parent('#sylius-saved-cart').prepend(buildAlert(isoDfTranslations.cart_saved, 'success', true));
                        },
                        error: function(response) {
                            element.parent('#sylius-saved-cart').prepend(buildAlert(isoDfTranslations.unknown_error, 'danger', true));
                        }
                    });

                } else {
                    element.parent('#sylius-saved-cart').prepend(buildAlert(isoDfTranslations.provide_list_name, 'warning', true));
                }

                e.preventDefault();
            });
        },
        shareCart: function () {
            var element = $(this);
            var csrfToken = $(element).data('csrf-token');
            var dataUrl = $(element).data('url');

            $(this).on('click', function(e) {

                $(this).attr('disabled', 'disabled');

                $.ajax({
                    method: 'POST',
                    url: dataUrl,
                    cache: false,
                    data: { _csrf_token : csrfToken },
                    success: function (response) {
                        //console.log(response);
                        $('#isoshop-shared-cart').html('<input class="form-control"><button class="btn iso-df-btn-copy-link">' + isoDfTranslations.copy_link + '</button>');
                        $('#isoshop-shared-cart input').val(response.url);
                        $('#isoshop-shared-cart button').on('click', function (e) {
                            e.preventDefault();
                            copyLinkToClipboard();
                        });
                    },
                    error: function(response) {
                        alert("Error");
                    }
                });

                e.preventDefault();
            });
        }

    });



})( jQuery );

$(document).ready( function() {
    $(document).variantPrices();
    $(document).provinceField();
    $('#isoshop-save-cart').saveCart();
    $('#isoshop-share-cart').shareCart();

    isoDfLayoutQtySpinner.init();
    isoDfLayoutCheckboxVisibilityToggle.init();

    $('.address-book-select li').on('click', function() {
        var addressSelected = $(this);
        var element = addressSelected.parents('.a-form');
        var inputs = element.find('input');

        $.each(inputs, function (key, input) {
            $(input).val('');
        });

        var parseKey = function (key) {
            return key.replace(/(_\w)/g, function (m) {return m[1].toUpperCase()});
        }

        $.each(addressSelected.data(), function (key, property) {
            element.find('input[name*='+ parseKey(key) +']').val(property);
        });
    });

    // quickview modal open
    $('.shop-product-card .buy-btn, .saved-cart-link, .cart-item-link').on('click', function(e) {
        $('#quick-view-product-modal').remove();
        var ajaxURL = $(this).data('ajax-url');
        $.get( ajaxURL, function( modalHTML ) {
            $('body').append( modalHTML );
            $('#quick-view-product-modal').modal('toggle');

            $('#quick-view-product-modal').on('shown.bs.modal', function () {
                setTimeout( function() {
                    initQuickviewGallery();
                }, 200);
            });

            if ($('#quick-view-product-modal #sylius-variants-pricing').length > 0) {
                handleProductOptionsChange();
            } else if ($("#quick-view-product-modal #sylius-product-variants").length > 0) {
                handleProductVariantsChange();
            }
            $('#quick-view-product-modal #sylius-product-adding-to-cart').addToCart();
        });
        e.preventDefault();

    });

    $('.widget-item button').on('click', function (e) {
        e.preventDefault();
    });

    $('.slick-dots li a').on('click', function(e) {
        e.preventDefault();
    });

    // hover product box on touch screen
    $('.shop-product-card .shop-p-slider a').on('click', function (e) {
        if ("ontouchstart" in document.documentElement) {
            if (!$(this).hasClass('hovered')) {
                $(this).addClass('hovered');
                e.preventDefault();
            }
        }
    }).on('mouseleave', function () {
        $(this).removeClass('hovered');
    });

    // element position
    $('.forget-pass-link').parent('span').insertAfter($('#_password').siblings('label').first());

    // checkout total price calculate
    $('.iso-df-shipping-calculator input[type="radio"]').on('click change', function () {
        $('#iso_order_total').html($(this).siblings('.extra').data('order-total'));
    });

    $('.checkout-complete-trigger').on('click', function (e) {
        e.preventDefault();
        $('.iso-df-btn-goto-complete').trigger('click');
    });

    // scroll to first form error if not in viewport
    if ($('.iso-df-validation-error').length) {
        if (!$('.iso-df-validation-error').isInViewport()) {
            $('html, body').animate({
                scrollTop: $('.iso-df-validation-error').first().offset().top - 60
            }, 1000);
        }
    }

    // user account current page highlighted in menu
    $('.iso-df-page-account .shop-sidebar-vertical ul li a').each( function() {
        var currentURL =  window.location.href;
        if (currentURL.indexOf($(this).attr('href')) != -1) {
            $(this).parent().addClass('active');
        }
    });

    // no-touch screens top level menu items clickable
    $('html.no-touch #navbar .nav li.dropdown > a').on('click', function () {
        window.location.href = $(this).attr('href');
    });

    $('form[name=sylius_cart] .iso-df-btn-cart-goto-checkout, .iso-df-page-cart .goto-checkout-address').on('click', function (e) {
        var qtyChanged = false;
        $('form[name=sylius_cart] .iso-df-spinner input').each( function () {
            if ($(this).attr('new_value') && ($(this).attr('value') != $(this).attr('new_value'))) {
                qtyChanged = true;
            }
        });
        if (qtyChanged) {
            $('.update-cart-modal').modal('toggle');
            e.preventDefault();
        }
    });

    $('#iso-df-products-sorting').on('change', function () {
        window.location.href = $(this).find('option:selected').attr('data-href');
    });

    $('#iso-df-products-sorting option').each( function () {
        var currentURL =  window.location.href;
        if (currentURL.indexOf($(this).attr('data-href')) != -1) {
            $(this).attr('selected', true);
        }
    });
});
